import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, InputAdornment, Tooltip, IconButton, Box, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, FormControlLabel } from '@mui/material'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import FileUploadGroup from './FileUploadGroup';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { useForm, Controller } from 'react-hook-form';
import HelpIcon from '@mui/icons-material/Help';
import * as charityActions from '../../store/actions/charitableActivity';
import { useParams, useNavigate } from 'react-router-dom';
import * as Styled from '../../components/styled-components/Styled-Components';
import { useLogout } from '../../components/Utils';
import CloseIcon from '@mui/icons-material/Close';
import DefaultTable from '../../components/MainTableNested'; // Import DefaultTable
import NestedTable from '../../components/NestedTable'; // Import DefaultTable
import { useTranslation } from 'react-i18next';
// import moment from 'moment';
import { CalculateUTCTzToUserTz } from '../../components/Utils';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxHeight: '80vh', // Adjust height as needed
    overflowY: 'auto', // Enables vertical scrolling
    bgcolor: 'background.paper',
    borderRadius: '4px',
    boxShadow: 24,
    p: 4,
  };
  


const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};
const textboxCss1 = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "11px 14px 10px 0",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid transparent`,

    },
    '& .MuiInputBase-fullWidth': {
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
        paddingRight: '10px !important'
    },
    '& fieldset' : {
        borderColor : 'transparent'
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};
const textboxCss2 = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "11px 14px 10px  14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid transparent`,

    },
    '& .MuiInputBase-fullWidth': {
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
        paddingRight: '10px !important'
    },
    '& fieldset' : {
        borderColor : 'transparent'
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};

const ViewCharitableActivity = ({setBreadcrumb, getCharitableActivityDetails, charityDetails}) => {
    const { t } = useTranslation('common');

    const { register, handleSubmit, formState: { errors }, control } = useForm();
    const navigate = useNavigate();
    const onLogout = useLogout();
    const userDetails = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const { id } = useParams();
    const [charityData, setCharityData] = useState(null);
    const [imageDetails, setImageDetails] = useState([]);
    const [auditData, setAuditData] = useState([]);

    // const [open, setOpen] = useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);

    useEffect(() => {
        const subMenuData = {
            name: t("Charitable Activities"),
            route: "/charitable-activity",
            subRoutes: "view-charitable-activity",
            subRoutesLabel: t("View"),
            isSubMenu: true
        }

        setBreadcrumb(subMenuData)
      }, []);

      useEffect(() => {
        getCharitableActivityDetails(id);
      },[]);

    useEffect(() => {
        if (charityDetails && charityDetails?.data && charityDetails?.data?.status === 200) {
            setCharityData(charityDetails?.data?.data);
            setImageDetails(charityDetails?.data?.data?.imageDetails);
            setAuditData(charityDetails?.auditLogDetails);
        }else if (charityDetails && charityDetails?.status === 401) {
            onLogout();
        } else if (charityDetails?.isError && !charityDetails?.isLoading) {
        }
    }, [charityDetails]);

    const headers = [
        { name: t('Date & Time')},
        { name: t('User')},
        { name: t('Change log')}
      ];
      const auditTableData = charityData?.auditLogDetails?.map((log, index) => ({
        id: (index + 1).toString(),
        col1: moment(CalculateUTCTzToUserTz(log?.timestamp)).format('M/D/YYYY, h:mm:ss A'),
        col2: log?.email ? `${log?.name} (${log?.email})` : log?.name,
        changeLog: log.changeLog
      }));
      
      const accessor = ['col1', 'col2'];
      const loadRowDetails = <div>{t("Row details content here")}</div>;

    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={12} lg={6} md={6}  style={{display:  'flex', justifyContent: 'space-between'}}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("Charitable Activities")}</b></h1>
                </Grid>
            </Grid>
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Business Unit")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                margin="normal"
                                id="businessUnitName"
                                sx={textboxCss}
                                value={charityData?.businessUnitName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "business unit name" }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Location")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                margin="normal"
                                id="location"
                                sx={textboxCss}
                                value={charityData?.businessUnitLocationName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "location" }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Address")}</Typography>
                            <TextField
                                margin="normal"
                                id="address"
                                sx={textboxCss}
                                value={charityData?.address}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "address" }}
                            />
                        </div>
                    </Grid>
                    
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Activity Date")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="eventStartDate"
                                control={control}
                                render={({ field: { onChange, onBlur, value }, fieldState }) => (
                                    <>
                                <DatePicker
                                    sx={textboxCss}
                                    className='input-text-box mt-0' 
                                    dayPlaceholder='DD'
                                    monthPlaceholder='MM'
                                    yearPlaceholder='YYYY'
                                    disabled
                                    value={charityData?.eventStartDate ? new Date(`${charityData?.eventStartDate}T00:00:00`) : null}
                                />
                                </>
                                )}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                           <div>
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Charity Name")}</Typography>
                            <TextField
                                margin="normal"
                                id="charityname"
                                sx={textboxCss}
                                value={charityData?.charityName || ""}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "charity name" }}
                            />
                        </div>
                    </Grid>
                   
                    
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div>
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>
                                {t("Activity Type")} <span style={{color:"red"}}>{" *"}</span>
                            </Typography>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={charityData?.activityType === 'charity'}
                                            disabled
                                            sx={{ color: appConfig.colors.darkblue, '&.Mui-checked': { color: appConfig.colors.darkblue } }}
                                        />
                                    }
                                    label={<Typography component="span" className='xxs-normal' sx={{ color: appConfig.colors.black }}>{t("Charity")}</Typography>}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={charityData?.activityType === 'hr_event'}
                                            disabled
                                            sx={{ color: appConfig.colors.darkblue, '&.Mui-checked': { color: appConfig.colors.darkblue } }}
                                        />
                                    }
                                    label={<Typography component="span" className='xxs-normal' sx={{ color: appConfig.colors.black }}>{t("HR Event")}</Typography>}
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Activity Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                margin="normal"
                                id="name"
                                sx={textboxCss}
                                value={charityData?.eventName || ""}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "event name" }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mt: 1, color: appConfig.colors.black, background: appConfig.colors.lightGray, padding: "10px !important" }} className='xxs-bold'>{t("Giving Amounts")}</Typography>
                    </Grid>  
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Total Amount of funds Martinrea international (company not employee) has donated to this activity?")}&nbsp;
                            <Tooltip title={t("These are funds provided by your location that are usually driven by HR and/or your GM through sponsorships, charity events etc")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <span><HelpIcon fontSize='10px'/></span>
                            </Tooltip>
                            </Typography>
                            <TextField
                                margin="normal"
                                id="totalmartinreafunds"
                                sx={textboxCss1}
                                value={charityData?.totalAmount || ""}
                                disabled
                                className='input-box'
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" style={{paddingLeft: 15, fontSize: 14, fontFamily: appConfig.fontfamily, textTransform: 'uppercase'}}><span style={{fontSize: 14}}>{charityData?.currency}</span></InputAdornment>,
                                }}
                                inputProps={{ "aria-label": "total funds" }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Total Amount of employee raised funds?")}&nbsp;
                            <Tooltip title={t("These are funds that are primarily raised or driven by employee fundraising through bake sales, raffles, etc.")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <span><HelpIcon fontSize='10px'/></span>
                            </Tooltip>
                            </Typography>
                            <TextField
                                margin="normal"
                                id="amountofemployee"
                                sx={textboxCss1}
                                value={charityData?.employeeFund || ""}
                                disabled
                                className='input-box'
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" style={{paddingLeft: 15, fontSize: 14, fontFamily: appConfig.fontfamily, textTransform: 'uppercase'}}><span style={{fontSize: 14}}>{charityData?.currency}</span></InputAdornment>,
                                }}
                                inputProps={{ "aria-label": "amount of employee" }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Estimated Volunteer hours donated to this activity?")}</Typography>
                            <TextField
                                margin="normal"
                                id="volunteerhours"
                                sx={textboxCss2}
                                value={charityData?.volunteerHours || ""}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "volunteer hours" }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{t("Hours")}</InputAdornment>,
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mt: 1, color: appConfig.colors.black, background: appConfig.colors.lightGray, padding: "10px !important" }} className='xxs-bold'>{t("Stories & Attachments")}</Typography>
                    </Grid>  
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Comment/Stories on the Impact of Giving")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                margin="normal"
                                id="comments"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                value={charityData?.comments || ""}
                                disabled
                                inputProps={{ "aria-label": "comments" }}
                                laceholder=""
                                multiline
                                rows={3}
                                maxRows={3}
                            />
                        </div>
                    </Grid>
                    
                    {imageDetails &&  imageDetails?.length !== 0 && (
                        <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div>                            
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Upload photos and/or videos")}&nbsp;
                            <Tooltip title={t("Please attach images separately as high resolution JPG/PNG/JPEG/GIF/BMP/WEBP and videos MP4/WEBM/OGG/MKV/AVI files, NOT embedded in other document types such as Word or PowerPoint")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <span><HelpIcon fontSize='10px'/></span>
                            </Tooltip>
                            </Typography>
                            <FileUploadGroup imageDetails={imageDetails} page="view" />
                        </div>
                    </Grid>
                    )}
                    
                </Grid>
                {(charityData?.auditLogDetails?.length === 0 || userDetails?.roleId === 202) && (
                    <Grid container spacing={2} style={{display: 'flex', justifyContent: 'left'}}>
                        <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                            <Styled.CancelButton
                                variant="outlined"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                                color="primary"
                                className="xxs-bold"
                                onClick={() => navigate(-1)}
                            >
                                {t("Cancel")}
                            </Styled.CancelButton>
                        </Grid>
                    </Grid>
                )}
               
                {charityData?.auditLogDetails && charityData?.auditLogDetails?.length !== 0 && userDetails?.roleId === 201 && (
                    <Grid container spacing={2}>
                        <Grid item  sm={12} xs={12}>
                            <Box style={{padding: 20}}>
                                <Typography variant="h6" component="h2" style={{marginBottom: 20}}>
                                    <b>{t("Change Log")}</b>
                                </Typography>
                                <hr className='blue-border' style={{marginBottom: 35}}/>
                                <DefaultTable
                                    headers={headers}
                                    data={auditTableData}
                                    accessor={accessor}
                                    sortValue={{ sortBy: 'col1', sortOrder: 'asc' }}
                                    hasDetails={true}
                                    loadRowDetails={loadRowDetails}
                                />
                            </Box>
                        </Grid>
                        <Grid container spacing={2} style={{justifyContent: 'center'}}>
                            <Grid item md={4.1} xl={4.1} lg={4.1} sm={12} xs={12}>
                                <Styled.CancelButton
                                    variant="outlined"
                                    sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                                    color="primary"
                                    className="xxs-bold"
                                    onClick={() => navigate(-1)}
                                >
                                    {t("Cancel")}
                                </Styled.CancelButton>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                
            </form>
    </div >
}

ViewCharitableActivity.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    getCharitableActivityDetails: PropTypes.func.isRequired,
    charityDetails: PropTypes.func.isRequired.isRequired,
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        getCharitableActivityDetails: (data) => dispatch(charityActions.getCharitableActivityDetails(data)),
    };
}
const mapStateToProps = (state) => ({ 
    charityDetails: state.charitableActivity.charityDetails
 })


export default connect(mapStateToProps, mapDispatchToProps)(ViewCharitableActivity);
